export const IconPlusFile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.66667 14.6654H12C12.3536 14.6654 12.6928 14.5249 12.9428 14.2748C13.1929 14.0248 13.3333 13.6857 13.3333 13.332V4.66536L10 1.33203H4C3.64638 1.33203 3.30724 1.47251 3.05719 1.72256C2.80714 1.9726 2.66667 2.31174 2.66667 2.66536V5.33203M9.33333 1.33203V3.9987C9.33333 4.35232 9.47381 4.69146 9.72386 4.94151C9.97391 5.19156 10.313 5.33203 10.6667 5.33203H13.3333M2 9.9987H6M4 7.9987V11.9987"
        stroke="#09090B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
